// src/App.js
import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Link,
} from "react-router-dom";

// Auth
import Login from "./components/Auth/Login";
import Register from "./components/Auth/Register";

// Dashboard / plataforma
import Dashboard from "./components/Dashboard/dashboard";
import UnifiedDashboard from "./components/Dashboard/UnifiedDashboard";
import MetaCampaigns from "./components/Dashboard/MetaCampaigns";

// Campanhas / estratégia / pricing / relatórios
import CampaignForm from "./components/Campaign/Campaign Creation/CampaignForm";
import CampaignSuccess from "./components/Campaign/Campaign Creation/CampaignSuccess";
import StrategyForm from "./components/Strategy/StrategyForm";
import GoogleAdsCampaignForm from "./components/Dashboard/GoogleAdsCampaignForm";
import PricingPage from "./components/Pricing/PricingPage";
import ReportsPanel from "./components/Reports/ReportsPanel";

// Pagamento
import Success from "./components/Payment/Success";
import Cancel from "./components/Payment/Cancel";

// Callback Google
import GoogleCallback from "./pages/GoogleCallback";

// ===================================================================
// HEADER DE TESTE / NAVEGAÇÃO (aquele bloco colorido lá de cima)
// ===================================================================
const RouteTestHeader = () => {
  const location = useLocation();

  return (
    <div
      style={{
        padding: "10px 20px",
        backgroundColor: "#f5f5f5",
        borderBottom: "2px solid #ddd",
        textAlign: "center",
      }}
    >
      <h2 style={{ margin: 0 }}>🧪 TESTE DOS COMPONENTES REAIS</h2>
      <p style={{ margin: "4px 0 12px" }}>
        <strong>Rota atual:</strong> {location.pathname}
      </p>

      <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
        <Link to="/dashboard">
          <button style={{ padding: "4px 10px" }}>Dashboard</button>
        </Link>
        <Link to="/unified-dashboard">
          <button style={{ padding: "4px 10px" }}>Unified Dashboard</button>
        </Link>
        <Link to="/create-campaign">
          <button style={{ padding: "4px 10px" }}>Criar Campanha</button>
        </Link>
        <Link to="/login">
          <button style={{ padding: "4px 10px", background: "#00a000", color: "#fff" }}>
            Login
          </button>
        </Link>
        <Link to="/register">
          <button style={{ padding: "4px 10px", background: "#a000a0", color: "#fff" }}>
            Register
          </button>
        </Link>
        <Link to="/strategy">
          <button style={{ padding: "4px 10px", background: "#009000", color: "#fff" }}>
            Strategy
          </button>
        </Link>
        <Link to="/google-ads">
          <button style={{ padding: "4px 10px", background: "#ff8000", color: "#fff" }}>
            Google Ads
          </button>
        </Link>
        <Link to="/reports">
          <button style={{ padding: "4px 10px", background: "#8000ff", color: "#fff" }}>
            Reports
          </button>
        </Link>
        <Link to="/pricing">
          <button style={{ padding: "4px 10px", background: "#ff9900", color: "#fff" }}>
            Pricing
          </button>
        </Link>
      </div>
    </div>
  );
};

// ===================================================================
// WRAPPER PARA PÁGINAS INTERNAS (com o header em cima)
// ===================================================================
const PageWrapper = ({ children }) => (
  <div>
    <RouteTestHeader />
    {children}
  </div>
);

function App() {
  console.log("🚀 APP CARREGADO - COMPONENTES REAIS");

  return (
    <BrowserRouter>
      <Routes>
        {/* ROTA INICIAL → Dashboard com header */}
        <Route
          path="/"
          element={
            <PageWrapper>
              <Dashboard />
            </PageWrapper>
          }
        />

        {/* ROTAS PÚBLICAS (SEM HEADER) */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* ROTAS INTERNAS (COM HEADER) */}
        <Route
          path="/dashboard"
          element={
            <PageWrapper>
              <Dashboard />
            </PageWrapper>
          }
        />

        <Route
          path="/unified-dashboard"
          element={
            <PageWrapper>
              <UnifiedDashboard />
            </PageWrapper>
          }
        />

        <Route
          path="/create-campaign"
          element={
            <PageWrapper>
              <CampaignForm />
            </PageWrapper>
          }
        />

        <Route
          path="/meta/campaigns"
          element={
            <PageWrapper>
              <MetaCampaigns />
            </PageWrapper>
          }
        />

        <Route
          path="/campaign-success"
          element={
            <PageWrapper>
              <CampaignSuccess />
            </PageWrapper>
          }
        />

        <Route
          path="/strategy"
          element={
            <PageWrapper>
              <StrategyForm />
            </PageWrapper>
          }
        />

        <Route
          path="/google-ads"
          element={
            <PageWrapper>
              <GoogleAdsCampaignForm />
            </PageWrapper>
          }
        />

        <Route
          path="/pricing"
          element={
            <PageWrapper>
              <PricingPage />
            </PageWrapper>
          }
        />

        <Route
          path="/reports"
          element={
            <PageWrapper>
              <ReportsPanel />
            </PageWrapper>
          }
        />

        {/* Pagamentos (se quiser com header também, deixa com PageWrapper) */}
        <Route
          path="/payment/success"
          element={
            <PageWrapper>
              <Success />
            </PageWrapper>
          }
        />
        <Route
          path="/payment/cancel"
          element={
            <PageWrapper>
              <Cancel />
            </PageWrapper>
          }
        />

        {/* Callback Google (deixar sem header mesmo) */}
        <Route path="/auth/google/callback" element={<GoogleCallback />} />

        {/* 404 */}
        <Route
          path="*"
          element={
            <div style={{ padding: 50, textAlign: "center" }}>
              <h1>❌ 404 - Página não encontrada</h1>
              <p>A rota que você tentou acessar não existe.</p>
              <Link
                to="/"
                style={{
                  padding: "10px 20px",
                  background: "blue",
                  color: "white",
                  textDecoration: "none",
                  borderRadius: 5,
                }}
              >
                Voltar ao Dashboard
              </Link>
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
